class NumberValidatorInput extends HTMLInputElement {
  constructor() {
    super();
    this.validateInput = this.validateInput.bind(this);
    this.enforceMaxLength = this.enforceMaxLength.bind(this);
  }

  connectedCallback() {
    this.addEventListener('keypress', this.validateInput);
    if (this.maxLength > 0) {
      this.addEventListener('input', this.enforceMaxLength);
      this.enforceMaxLength();
    }
  }

  disconnectedCallback() {
    this.removeEventListener('keypress', this.validateInput);
    if (this.maxLength > 0) {
      this.removeEventListener('input', this.enforceMaxLength);
    }
  }

  validateInput(e) {
    const charCode = e.which || e.keyCode;
    const isValidKey =
      charCode === 8 || // backspace
      charCode === 0 || // null
      (charCode >= 48 && charCode <= 57); // digits 0–9

    if (!isValidKey) {
      e.preventDefault();
      return;
    }

    if (this.maxLength > 0 && charCode >= 48 && charCode <= 57) {
      const hasSelection = this.selectionStart !== this.selectionEnd;
      const digits = this.value.replace(/\D/g, '');
      if (!hasSelection && digits.length >= this.maxLength) {
        e.preventDefault();
      }
    }
  }

  enforceMaxLength() {
    const digits = this.value.replace(/\D/g, '').slice(0, this.maxLength);
    if (this.value !== digits) {
      this.value = digits;
    }
  }
}

customElements.define('number-validator', NumberValidatorInput, { extends: 'input' });
